import React from "react";
import Typist from 'react-typist';
import 'react-typist/dist/Typist.css'
import messages from '../components/messages';
import HeadlineWithFocus from "../components/HeadlineWithFocus";
import first from "../assets/images/kaikouraEQ/1.png";
import second from "../assets/images/kaikouraEQ/2.png";
import third from "../assets/images/kaikouraEQ/3.png";
import fourth from "../assets/images/kaikouraEQ/4.png";
import fifth from "../assets/images/kaikouraEQ/5.png";
import sixth from "../assets/images/kaikouraEQ/6.png";
import seventh from "../assets/images/kaikouraEQ/7.png";

const Index = props => {
  return (
      <div className="c-content-box">
        <h2>Reconnaissance after the 2016 Kaikoura EQ (New Zealand)</h2>
          <div style={{ textAlign: 'justify', lineHeight: '2em'}}>

          <img src={first} style={{ width: '100%', height: '100%' }} />

          The Magnitude (Mw) 7.8 Kaikoura Earthquake hit New Zealand on 14 November 2016, causing two deaths and immense damage, particularly to infrastructures. In that period, I was there studying at the University of Canterbury (UC) and therefore I had the incredible opportunity to participate to the post-earthquake damage reconnaissance for bridges led by Alessandro Palermo at UC. <br /> <br />

          Directly from the reality, I learnt about the structural performance of the most severely damaged bridges which in most cases suffered major damage without total collapse. In my opinion, this is an example of very good design. <br /> <br />

          Interestingly, in some regions the vertical peak ground acceleration (PGA) was measured to be 2.7g. This is basically something able to lift objects from the ground. There is evidence that this happened for at least one bridge deck, which suffered unseating from its rubber bearing pads. <br /> <br />

          Below I’m showing a few photos from the reconnaissance. <br /> <br />

          <img src={second} style={{ width: '100%', height: '100%' }} /> <br /> <br />
          <img src={third} style={{ width: '100%', height: '100%' }} /> <br /> <br />
          <img src={fourth} style={{ width: '100%', height: '100%' }} /> <br /> <br />
          <img src={fifth} style={{ width: '100%', height: '100%' }} /> <br /> <br />
          <img src={sixth} style={{ width: '100%', height: '100%' }} /> <br /> <br />
          <img src={seventh} style={{ width: '100%', height: '100%' }} /> <br /> <br />

        </div>
      </div>
  );
};

export default Index;



// WEBPACK FOOTER //
// ./src/pages/kaikoura.en.jsx